class GiftingOptions extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.updateGiftOption = this.updateGiftOption.bind(this)
    this.updateInnerOverlay = this.updateInnerOverlay.bind(this)
    this.clearSelections = this.clearSelections.bind(this)
    this.checkMessageValue = this.checkMessageValue.bind(this)
    this.populateExistingGiftMessage = this.populateExistingGiftMessage.bind(this)
    this.openOptions = this.openOptions.bind(this)

    if (this.externalEls?.editTrigger?.exists) {
      this.listeners.add(this.externalEls.editTrigger.element, 'click', this.openOptions)
    }

    for (const optionEl of this.els.option.elements) {
      this.listeners.add(optionEl, 'click', this.updateGiftOption)
    }

    if (this.externalEls?.innerOverlay?.exists) {
      this.listeners.add(this.externalEls.innerOverlay.element, 'click', this.updateInnerOverlay)
    }

    if (this.externalEls?.accordionTrigger?.exists) {
      for (const accordionEl of this.externalEls.accordionTrigger.elements) {
        this.listeners.add(accordionEl, 'click', this.updateInnerOverlay)
      }
    }

    this.listeners.add(this.els.clear.element, 'click', () => {
      this.clearSelections()
      this.clearTextarea()
    })

    this.listeners.add(this.els.message.element, 'input', this.checkMessageValue)

    this.listeners.add(window, 'load', this.populateExistingGiftMessage)
  }

  async populateExistingGiftMessage () {
    const cart = await window.BAO.Utils.fetchJSON('/cart.json')

    if (!cart.note) {
      return
    }

    this.els.message.element.value = cart.note
  }

  openOptions (event) {
    // create a pesudo click event to open the accordion
    this.externalEls.accordionTrigger.element.click()
  }

  updateGiftOption (event) {
    this.els.hiddenGiftOption.element.value = event.target.value
    this.els.hiddenGiftOptionQuantity.element.value = 1

    this.updateClearButton()
  }

  checkMessageValue (event) {
    if (this.els.message.element.value.length > 0) {
      this.els.clear.element.setAttribute('aria-hidden', 'false')
    } else {
      this.els.clear.element.setAttribute('aria-hidden', 'true')
    }

    this.updateHiddenGiftMessage(event)
  }

  updateHiddenGiftMessage (event) {
    this.els.hiddenCartMessage.element.value = event.target.value
  }

  updateClearButton () {
    const anyOptionSelected = this.els.option.elements.some(optionEl => optionEl.checked)

    this.els.clear.element.setAttribute('aria-hidden', anyOptionSelected ? 'false' : 'true')
  }

  clearSelections () {
    for (const optionEl of this.els.option.elements) {
      optionEl.checked = false
    }

    this.els.hiddenGiftOption.element.value = ''
    this.els.clear.element.setAttribute('aria-hidden', 'true')

    this.els.hiddenGiftOptionQuantity.element.value = 0
  }

  clearTextarea () {
    this.els.message.element.value = ''
  }

  updateInnerOverlay (event) {
    const innerOverlay = this.externalEls?.innerOverlay?.element

    if (!innerOverlay) {
      return
    }

    const isHidden = innerOverlay.getAttribute('aria-hidden') === 'true'
    innerOverlay.setAttribute('aria-hidden', isHidden ? 'false' : 'true')

    if (event.target === innerOverlay) {
      this.updateActiveAccordions()
    }
  }

  updateActiveAccordions () {
    const activeAccordions = this.externalEls.accordionTrigger.elements.filter(accordion => {
      const parent = accordion.closest('[data-accordion-group-el="item"]')
      return parent.getAttribute('aria-expanded') === 'true'
    })

    for (const accordion of activeAccordions) {
      const parent = accordion.closest('[data-accordion-group-el="item"]')
      parent.setAttribute('aria-expanded', 'false')
    }
  }
}

customElements.define('gifting-options', GiftingOptions)
